// 설정은 lib/branchConfig.js 한 곳에 모였다 (#851).
// 앱마다 설정 파일이 둘이라 branchId 가 양쪽에 있었고 import 가 혼용됐다.
// 기존 import 경로를 깨지 않으려고 이 파일은 재수출만 남긴다.
export { branchConfig } from "@/lib/branchConfig";
